// Enums do domínio. Fonte: Documentação Técnica v1.14, seção 4.
// Usados por API, web e admin; valores persistidos no banco como texto.
export const UserStatus = { ACTIVE: 'ACTIVE', DISABLED: 'DISABLED' };
export const MemberRole = { ADMIN: 'ADMIN', STANDARD: 'STANDARD' };
export const MemberStatus = { ACTIVE: 'ACTIVE', REMOVED: 'REMOVED' };
/** WEB: refresh em cookie httpOnly. MOBILE: refresh no corpo (app Flutter, guardado no keychain/keystore). ADMIN: painel com TOTP. */
export const SessionKind = { WEB: 'WEB', MOBILE: 'MOBILE', ADMIN: 'ADMIN' };
export const InviteStatus = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    EXPIRED: 'EXPIRED',
    REVOKED: 'REVOKED',
};
export const BusinessStatus = {
    TRIAL: 'TRIAL',
    ACTIVE: 'ACTIVE',
    QUOTA_EXHAUSTED: 'QUOTA_EXHAUSTED',
    PAUSED: 'PAUSED',
    SUSPENDED: 'SUSPENDED',
    CANCELLED: 'CANCELLED',
};
export const Modality = { LOCAL: 'LOCAL', HOME: 'HOME', BOTH: 'BOTH' };
export const AppointmentModality = { LOCAL: 'LOCAL', HOME: 'HOME' };
export const PriceVisibility = { SHOW: 'SHOW', HIDE: 'HIDE', ON_REQUEST: 'ON_REQUEST' };
export const RoutingRule = {
    ASK_PREFERENCE: 'ASK_PREFERENCE',
    FIRST_AVAILABLE: 'FIRST_AVAILABLE',
    ROUND_ROBIN: 'ROUND_ROBIN',
    LAST_ATTENDED: 'LAST_ATTENDED',
};
export const ClientVisibility = { ALL: 'ALL', OWN: 'OWN', NONE: 'NONE' };
export const ResourceStatus = { ACTIVE: 'ACTIVE', INACTIVE: 'INACTIVE' };
export const HomeServiceMode = { REGIONS: 'REGIONS', RADIUS: 'RADIUS' };
export const ClientStatus = {
    ACTIVE: 'ACTIVE',
    BLOCKED_CONTACT: 'BLOCKED_CONTACT',
    NO_BOOKING: 'NO_BOOKING',
};
export const AppointmentStatus = {
    CONFIRMED: 'CONFIRMED',
    DONE: 'DONE',
    NO_SHOW: 'NO_SHOW',
    CANCELLED_BY_CLIENT: 'CANCELLED_BY_CLIENT',
    CANCELLED_BY_BUSINESS: 'CANCELLED_BY_BUSINESS',
    CANCELLED_NO_CONFIRMATION: 'CANCELLED_NO_CONFIRMATION',
    RESCHEDULED: 'RESCHEDULED',
};
export const ConfirmationStatus = {
    NOT_REQUESTED: 'NOT_REQUESTED',
    REQUESTED: 'REQUESTED',
    CONFIRMED: 'CONFIRMED',
    UNANSWERED: 'UNANSWERED',
};
export const AppointmentOrigin = {
    AI: 'AI',
    MANUAL: 'MANUAL',
    WAITLIST: 'WAITLIST',
    REACTIVATION: 'REACTIVATION',
};
export const HoldKind = { AI_OFFER: 'AI_OFFER', WAITLIST_OFFER: 'WAITLIST_OFFER' };
export const HoldStatus = {
    ACTIVE: 'ACTIVE',
    CONSUMED: 'CONSUMED',
    EXPIRED: 'EXPIRED',
    RELEASED: 'RELEASED',
};
export const OccupancySubject = { MEMBER: 'MEMBER', RESOURCE: 'RESOURCE' };
export const OccupancyKind = { APPOINTMENT: 'APPOINTMENT', HOLD: 'HOLD' };
export const WaitlistRequestStatus = {
    WAITING: 'WAITING',
    OFFERED: 'OFFERED',
    ACCEPTED: 'ACCEPTED',
    DECLINED: 'DECLINED',
    EXPIRED: 'EXPIRED',
    CLOSED: 'CLOSED',
};
export const WaitlistOfferStatus = {
    PENDING: 'PENDING',
    SOFT: 'SOFT',
    ACCEPTED: 'ACCEPTED',
    DECLINED: 'DECLINED',
    EXPIRED: 'EXPIRED',
};
export const ConversationState = {
    AI_ACTIVE: 'AI_ACTIVE',
    HUMAN_ASSIGNED: 'HUMAN_ASSIGNED',
    WAITING_CLIENT: 'WAITING_CLIENT',
    RESUME_PENDING: 'RESUME_PENDING',
};
export const ConversationKind = { CLIENT: 'CLIENT', MEMBER: 'MEMBER' };
export const MessageDirection = { IN: 'IN', OUT: 'OUT' };
export const AuthorType = { CLIENT: 'CLIENT', AI: 'AI', USER: 'USER', SYSTEM: 'SYSTEM' };
export const DeliveryStatus = {
    PENDING: 'PENDING',
    SENT: 'SENT',
    DELIVERED: 'DELIVERED',
    READ: 'READ',
    FAILED: 'FAILED',
};
export const MediaType = {
    TEXT: 'TEXT',
    AUDIO: 'AUDIO',
    IMAGE: 'IMAGE',
    DOCUMENT: 'DOCUMENT',
    VIDEO: 'VIDEO',
    OTHER: 'OTHER',
};
export const OutboundIntent = {
    REMINDER: 'REMINDER',
    CONFIRMATION: 'CONFIRMATION',
    WAITLIST: 'WAITLIST',
    REACTIVATION: 'REACTIVATION',
    SUMMARY: 'SUMMARY',
    HUMAN_REPLY: 'HUMAN_REPLY',
    AI_REPLY: 'AI_REPLY',
    OPERATIONAL: 'OPERATIONAL',
    SYSTEM_NOTICE: 'SYSTEM_NOTICE',
};
export const TemplateStatus = {
    DRAFT: 'DRAFT',
    SUBMITTED: 'SUBMITTED',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    PAUSED: 'PAUSED',
};
export const TemplateCategory = { OPERATIONAL: 'OPERATIONAL', ENGAGEMENT: 'ENGAGEMENT' };
export const TemplatePurpose = {
    REMINDER: 'REMINDER',
    CONFIRMATION_REQUEST: 'CONFIRMATION_REQUEST',
    RESCHEDULE: 'RESCHEDULE',
    /** Negócio pede ao cliente para trocar o horário (sem obrigação); RESCHEDULE é a ausência da profissional. */
    RESCHEDULE_REQUEST: 'RESCHEDULE_REQUEST',
    CANCELLATION: 'CANCELLATION',
    RELEASE_NO_CONFIRMATION: 'RELEASE_NO_CONFIRMATION',
    WAITLIST_OFFER: 'WAITLIST_OFFER',
    REACTIVATION: 'REACTIVATION',
    RECOMMENDED_RETURN: 'RECOMMENDED_RETURN',
    DAILY_SUMMARY: 'DAILY_SUMMARY',
    WEEKLY_REPORT: 'WEEKLY_REPORT',
    APPOINTMENT_CONFIRMED: 'APPOINTMENT_CONFIRMED',
    UNAVAILABLE: 'UNAVAILABLE',
    MEMBER_NOTICE: 'MEMBER_NOTICE',
    /** Avisos específicos à equipe (a Meta classifica como Utility só com texto fixo e dados concretos). */
    TEAM_BOOKING: 'TEAM_BOOKING',
    TEAM_APPROVAL: 'TEAM_APPROVAL',
    TEAM_HANDOFF: 'TEAM_HANDOFF',
};
/** Finalidades com template geral (as de reativação são do próprio plano; as demais não têm envio). */
export const GENERAL_TEMPLATE_PURPOSES = ['REMINDER', 'CONFIRMATION_REQUEST', 'WAITLIST_OFFER', 'RESCHEDULE', 'RESCHEDULE_REQUEST', 'CANCELLATION', 'RELEASE_NO_CONFIRMATION', 'UNAVAILABLE', 'TEAM_BOOKING', 'TEAM_APPROVAL', 'TEAM_HANDOFF', 'DAILY_SUMMARY', 'WEEKLY_REPORT', 'MEMBER_NOTICE'];
export const PendingActionStatus = {
    PREVIEW: 'PREVIEW',
    CONFIRMED: 'CONFIRMED',
    EXECUTED: 'EXECUTED',
    REJECTED: 'REJECTED',
    FAILED: 'FAILED',
};
export const SubscriptionStatus = {
    TRIAL: 'TRIAL',
    ACTIVE: 'ACTIVE',
    PAST_DUE: 'PAST_DUE',
    CANCELLED: 'CANCELLED',
};
export const SubscriptionChangeKind = {
    UPGRADE_IMMEDIATE: 'UPGRADE_IMMEDIATE',
    DOWNGRADE_NEXT_CYCLE: 'DOWNGRADE_NEXT_CYCLE',
    DOWNGRADE_IMMEDIATE: 'DOWNGRADE_IMMEDIATE',
};
export const SubscriptionChangeStatus = {
    PENDING_PAYMENT: 'PENDING_PAYMENT',
    ACTIVE: 'ACTIVE',
    NEEDS_REVIEW: 'NEEDS_REVIEW',
    CANCELLED: 'CANCELLED',
    REVOKED: 'REVOKED',
};
export const InteractionPackStatus = {
    PENDING_PAYMENT: 'PENDING_PAYMENT',
    ACTIVE: 'ACTIVE',
    PARTIALLY_REVOKED: 'PARTIALLY_REVOKED',
    REVOKED: 'REVOKED',
    CANCELLED: 'CANCELLED',
};
export const BillingEntryType = {
    PLAN: 'PLAN',
    PACK: 'PACK',
    ADJUSTMENT: 'ADJUSTMENT',
    COURTESY: 'COURTESY',
};
export const BillingEntryStatus = {
    OPEN: 'OPEN',
    CONFIRMED: 'CONFIRMED',
    RECEIVED: 'RECEIVED',
    OVERDUE: 'OVERDUE',
    CANCELLED: 'CANCELLED',
    REFUND_PENDING: 'REFUND_PENDING',
    PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
    REFUNDED: 'REFUNDED',
    CHARGEBACK: 'CHARGEBACK',
    CHARGEBACK_REVERSED: 'CHARGEBACK_REVERSED',
};
export const PaymentMethod = {
    PIX: 'PIX',
    BOLETO: 'BOLETO',
    CARD: 'CARD',
    MANUAL: 'MANUAL',
    COURTESY: 'COURTESY',
    UNDEFINED: 'UNDEFINED',
};
export const BillingMovementType = {
    RECEIPT: 'RECEIPT',
    REFUND: 'REFUND',
    PARTIAL_REFUND: 'PARTIAL_REFUND',
    CHARGEBACK: 'CHARGEBACK',
    CHARGEBACK_REVERSAL: 'CHARGEBACK_REVERSAL',
    CASH_RECEIPT_UNDONE: 'CASH_RECEIPT_UNDONE',
};
export const MovementSourceType = { PROVIDER: 'PROVIDER', MANUAL: 'MANUAL', SYSTEM: 'SYSTEM' };
export const InvoiceStatus = {
    SCHEDULED: 'SCHEDULED',
    SYNCHRONIZED: 'SYNCHRONIZED',
    AUTHORIZED: 'AUTHORIZED',
    PROCESSING_CANCELLATION: 'PROCESSING_CANCELLATION',
    CANCELED: 'CANCELED',
    CANCELLATION_DENIED: 'CANCELLATION_DENIED',
    ERROR: 'ERROR',
};
/** META = App e credenciais do próprio negócio; META_EMBEDDED = App Koyomi via Embedded Signup (mesma Cloud API por baixo). */
export const WhatsAppProviderName = { EVOLUTION: 'EVOLUTION', ZAPI: 'ZAPI', META: 'META', META_EMBEDDED: 'META_EMBEDDED' };
export const ProviderStatus = {
    ACTIVE: 'ACTIVE',
    DEPRECATING: 'DEPRECATING',
    SUSPENDED: 'SUSPENDED',
};
export const ConnectionMode = {
    OFFICIAL_EXCLUSIVE: 'OFFICIAL_EXCLUSIVE',
    OFFICIAL_COEXISTENCE: 'OFFICIAL_COEXISTENCE',
    UNOFFICIAL: 'UNOFFICIAL',
};
export const ConnectionStatus = {
    DISCONNECTED: 'DISCONNECTED',
    QR_PENDING: 'QR_PENDING',
    SETUP_REQUIRED: 'SETUP_REQUIRED',
    CONNECTED: 'CONNECTED',
    DEGRADED: 'DEGRADED',
    BANNED: 'BANNED',
};
export const ActorType = { AI: 'AI', USER: 'USER', SUPER_ADMIN: 'SUPER_ADMIN', SYSTEM: 'SYSTEM' };
export const SupportAccessStatus = {
    REQUESTED: 'REQUESTED',
    APPROVED: 'APPROVED',
    DENIED: 'DENIED',
    REVOKED: 'REVOKED',
    EXPIRED: 'EXPIRED',
};
export const SupportAccessScope = {
    CONVERSATIONS: 'CONVERSATIONS',
    CLIENTS: 'CLIENTS',
    SETTINGS: 'SETTINGS',
};
export const IntegrationProvider = {
    ASAAS: 'ASAAS',
    RESEND: 'RESEND',
    ANTHROPIC: 'ANTHROPIC',
    OPENAI: 'OPENAI',
    GOOGLE_MAPS: 'GOOGLE_MAPS',
    R2: 'R2',
    /** Firebase Cloud Messaging: push do app (service account JSON). */
    FIREBASE: 'FIREBASE',
    /** API do Render: métricas de CPU, memória, disco e conexões para o painel de Infraestrutura do Admin. */
    RENDER: 'RENDER',
    /** Cloudflare Turnstile: anti-robô do cadastro pelo site (site key pública + secret). */
    TURNSTILE: 'TURNSTILE',
};
export const ProviderEventStatus = {
    RECEIVED: 'RECEIVED',
    PROCESSED: 'PROCESSED',
    IGNORED: 'IGNORED',
    FAILED: 'FAILED',
};
export const NoShowAction = {
    REQUIRE_CONFIRMATION: 'REQUIRE_CONFIRMATION',
    SUSPEND_AI_BOOKING: 'SUSPEND_AI_BOOKING',
    NOTIFY_ADMIN: 'NOTIFY_ADMIN',
};
export const UnansweredAction = { KEEP: 'KEEP', RELEASE: 'RELEASE' };
export const ConfigConflictResolution = {
    SUBSTITUTE: 'SUBSTITUTE',
    RESCHEDULE_VIA_AI: 'RESCHEDULE_VIA_AI',
    KEEP_AS_EXCEPTION: 'KEEP_AS_EXCEPTION',
};
export const Locale = { PT_BR: 'pt-BR', EN_US: 'en-US' };
export const FeatureFlag = {
    waitlist: 'waitlist',
    substitution: 'substitution',
    homeService: 'homeService',
    reactivation: 'reactivation',
    whatsappCommands: 'whatsappCommands',
    resources: 'resources',
};
//# sourceMappingURL=index.js.map